import React from "react";

function Info(props) {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.4974 0.917969C3.59377 0.917969 0.414062 4.09768 0.414062 8.0013C0.414062 11.9049 3.59377 15.0846 7.4974 15.0846C11.401 15.0846 14.5807 11.9049 14.5807 8.0013C14.5807 4.09768 11.401 0.917969 7.4974 0.917969ZM7.4974 2.33464C10.6354 2.33464 13.1641 4.8633 13.1641 8.0013C13.1641 11.1393 10.6354 13.668 7.4974 13.668C4.35939 13.668 1.83073 11.1393 1.83073 8.0013C1.83073 4.8633 4.35939 2.33464 7.4974 2.33464ZM6.78906 4.45964V5.8763H8.20573V4.45964H6.78906ZM6.78906 7.29297V11.543H8.20573V7.29297H6.78906Z"
        fill="#0F3444"
        fillOpacity={props.opacity ? "0.2" : "1"}
      />
    </svg>
  );
}

export default Info;
